import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LaptopIcon(props: IconProps) {
    return <Icon {...props} iconKey={"laptop"}/>
}
